import { Injectable, ComponentRef, Injector, ApplicationRef, Type, createComponent } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { RmsPopupComponent } from '../custom-modules/rms-module/rms-popup/rms-popup.component';
import { RmsPopupRef } from './RmsPopupRef';

@Injectable({ providedIn: 'root' })
export class PopupService {
  private popupRef: ComponentRef<RmsPopupComponent> | null = null;

  constructor(
    private appRef: ApplicationRef,
    private injector: Injector,
  ) { }

  openFileViewer(options: {
    title?: string;
    fileUrl: string;
    startingWidth?: string;
    startingHeight?: string;
  }) {
    return this.open({
      title: options.title ?? 'File Viewer',
      fileUrl: options.fileUrl,                 // ✅ proper typed prop now
      startingWidth: options.startingWidth ?? '92vw',
      startingHeight: options.startingHeight ?? '88vh'
    });
  }

  open<T>(options: {
    title?: string;
    reportUrl?: any;
    component?: Type<T>;
    customHtml?: SafeHtml;
    data?: any;
    startingWidth?: string;
    startingHeight?: string;

    // ✅ NEW: allow file viewer mode
    fileUrl?: string;
  }): { ref: RmsPopupRef<T>, instance: RmsPopupComponent } {

    if (this.popupRef) this.close();

    const rmsPopupRef = new RmsPopupRef<T>();

    const childInjector = Injector.create({
      providers: [{ provide: RmsPopupRef, useValue: rmsPopupRef }],
      parent: this.injector
    });

    this.popupRef = createComponent(RmsPopupComponent, {
      environmentInjector: this.appRef.injector,
      elementInjector: childInjector
    });

    const instance = this.popupRef.instance;

    // ✅ Set inputs synchronously and then load content
    instance.title = options.title ?? '';
    instance.reportUrl = options.reportUrl;
    instance.component = options.component;
    instance.customHtml = options.customHtml;
    instance.fileUrl = options.fileUrl;               // ✅ critical
    instance.data = { ...(options.data || {}), rmsPopupRef };
    instance.startingWidth = options.startingWidth;
    instance.startingHeight = options.startingHeight; // ✅ you were missing this

    this.appRef.attachView(this.popupRef.hostView);
    document.body.appendChild(this.popupRef.location.nativeElement);

    // Hook into default close
    instance.closeEvent.subscribe(() => this.close());

    // ✅ Ensure popup recalculates view mode + safeFileUrl AFTER inputs are set
    queueMicrotask(() => instance.loadContent());

    return { ref: rmsPopupRef, instance };
  }

  close() {
    if (this.popupRef) {
      this.appRef.detachView(this.popupRef.hostView);
      this.popupRef.destroy();
      this.popupRef = null;
    }
  }
}
